import React from 'react'
import styled from 'styled-components'
import Container from 'react-bootstrap/Container'
import { useSelector, useDispatch } from 'react-redux'
import { MainLayoutProps } from './types'
import Header from '../Header'
import Notification from '../Notification'
import { RootState } from 'app/state/types'
import { setIsShowNotification } from 'app/state/generalSlice'
// import Footer from 'app/components/Footer'

const RootContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: white;
    width: 100%;
    height: 100vh;
`

const StickyContainer = styled.div`
    z-index: 8000;
    top: 0;
    position: sticky;
`

const ContentContainer = styled(Container)`
    height: 90%;
`

const MainLayout = ({ children }: MainLayoutProps) => {
    const { notification, isShowNotification } = useSelector(
        (state: RootState) => state.generalSlice,
    )
    const dispatch = useDispatch()

    return (
        <RootContainer>
            <StickyContainer>
                <Header />
                <Notification
                    type={notification.type}
                    header={notification.header}
                    message={notification.message}
                    isVisible={isShowNotification}
                    onDismiss={() => dispatch(setIsShowNotification(false))}
                />
            </StickyContainer>
            <ContentContainer className="no-gutters">
                {children}
            </ContentContainer>
            {/*<Footer />*/}
        </RootContainer>
    )
}

export default MainLayout
